import type { ReactNode } from "react";
import "./page-header.css";

type Props = { eyebrow: string; title: string; actions?: ReactNode };

export function PageHeader({ eyebrow, title, actions }: Props) {
  return (
    <div className="g-page-head">
      <div>
        <p className="g-page-head__eyebrow">{eyebrow}</p>
        <h1 className="g-page-head__title">{title}</h1>
      </div>
      {actions ? <div className="g-page-head__actions">{actions}</div> : null}
    </div>
  );
}
